// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3wMVV","containerItemsCenter":"Skeleton_containerItemsCenter__18Vdv"};